import styled from "styled-components";
import Header from "@/components/main/Header";
import Footer from "@/components/main/Footer";
import { IFontProps } from "@/typings/Props";
import { useTranslation } from "react-i18next";
import Link from "next/link";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border: 3px solid rgba(1, 1, 1, 0);
  background-color: #f7f7f7;
`;
const SupportWrapper = styled.div`
  margin-top: 60px;
  width: 100%;
  height: 555px;
  @media (max-width: 1000px) {
    height: auto;
    padding: 40px;
  }
`;
const SupportContent = styled.div`
  max-width: 1244px;
  height: 488px;
  background-color: white;
  border-radius: 10px;
  margin: auto;
  display: flex;
  @media (max-width: 1000px) {
    width: 100%;
    height: auto;
    flex-direction: column;
  }
`;
const Area = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px;
  @media (max-width: 1000px) {
    width: 100%;
    height: 50%;
    padding: 20px;
  }
`;

const P = styled.p<IFontProps>`
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  color: ${(props) => props.$fontColor};
  margin-top: ${(props) => props.$marginTop};
  margin-right: ${(props) => props.$marginRight};
  text-align: ${(props) => props.$textAlign};
  white-space: pre-wrap;
  padding: 10px;
  @media (max-width: 1300px) {
    &#title {
      font-size: 2.5rem;
    }
  }
`;

const QrCode = styled(Link)`
  width: 100%;
  height: 300px;
  background-image: url("/contact-support/image-194.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
`;

export default function SupportRequest() {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <Container>
        <SupportWrapper>
          <SupportContent>
            <Area>
              <P
                id="title"
                $fontColor="#971b2f"
                $fontWeight="700"
                $fontSize="3.5rem"
                $lineHeight="150%"
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                {t("menu.support.support-request.title")}
              </P>
              <P $fontSize="1.7rem" $fontColor="#444444" $lineHeight="150%">
                {t("menu.support.support-request.desc-1")}
              </P>
              <P $fontColor="#676767">{t("menu.support.support-request.desc-2")}</P>
            </Area>
            <Area>
              <P $textAlign="center" $fontColor="#676767">
                {t("menu.support.support-request.qr-desc-1")}
              </P>
              <QrCode href="https://wa.link/clx2ul"></QrCode>
              <P $textAlign="center" $fontColor="#676767">
                {t("menu.support.support-request.qr-desc-2")}
              </P>
            </Area>
          </SupportContent>
        </SupportWrapper>
      </Container>

      <Footer />
    </>
  );
}
